import { PerStyleVariationMapBuilder } from "@faire/deprecated-retailer-visitor-shared/features/OpenSizing/PerStyleVariationMapBuilder";
import { Core } from "@faire/design-tokens";
import { PresetDateFormat } from "@faire/web/common/FaireDateRange";
import { intlDate } from "@faire/web/common/localization/date-fns/intlDate";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

export const OpenSizingVariationHelper: React.FC<{
  variation: PerStyleVariationMapBuilder.IPerStyleOptionVariation;
}> = ({ variation }) => {
  const shipDate = variation.showDatesInQuanitityPicker
    ? variation.expectedShipDate
    : undefined;
  const orderByDate = variation.showDatesInQuanitityPicker
    ? variation.orderByDate
    : undefined;

  if (!shipDate) {
    return null;
  }

  return (
    <Typography
      variant="labelSansRegular"
      color={Core.text.subdued}
      data-test-id={`open-sizing-${variation.size}-variation-shipping-suffix`}
    >
      {orderByDate ? (
        <StrictLocalMsg
          id="C/nVmr"
          defaultMessage="Preorder {shippingDate}. Order must be placed by {orderByDate}."
          description={{
            text: "Shipping date range label for product options variations that have to be preordered",
          }}
          values={{
            shippingDate:
              shipDate?.formatPresetDateRange(
                PresetDateFormat.ABBREVIATED_MMM_D
              ) ?? "",
            orderByDate: intlDate(orderByDate.localDateObject, "MMM d"),
          }}
        />
      ) : (
        <StrictLocalMsg
          id="7jcEyT"
          defaultMessage="Preorder {shippingDate}"
          description={{
            text: "Shipping date range label for product options variations that have to be preordered",
          }}
          values={{
            shippingDate:
              shipDate?.formatPresetDateRange(
                PresetDateFormat.ABBREVIATED_MMM_D
              ) ?? "",
          }}
        />
      )}
    </Typography>
  );
};
